import { fIDR } from "./../../../../../Service/Helper/Utils";

export const BillDetail = ({ currPeriod, fees = 0, discount, total= 0 }) => {
  const finalTotal = Number(total) + Number(fees)

  return (
  <div>
    <p className="text-uppercase text-muted mb-2" style={{ fontSize: 11, letterSpacing: "0.05em", fontWeight: 600 }}>
      Rincian Tagihan
    </p>
    <div className="d-flex justify-content-between mb-1" style={{ fontSize: 12 }}>
      <span className="text-muted">{currPeriod?.itemName}</span>
      <span className="text-muted">{currPeriod?.periodInvoice ?? "-"}</span>
    </div>
    <div key="Biaya Admin" className="d-flex justify-content-between py-1" style={{ fontSize: 13 }}>
      <span className="text-muted">Harga Layanan</span>
      <span className="fw-medium">{fIDR(total)}</span>
    </div>
    {!fees || (fees <= 0)
      ? <></>
      : (
        <div key={`Biaya Admin-{fees}`} className="d-flex justify-content-between py-1" style={{ fontSize: 13 }}>
          <span className="text-muted">Biaya Admin</span>
          <span className="fw-medium">{fIDR(fees)}</span>
        </div>
      )
    }
    {discount && (
      <div className="d-flex justify-content-between py-1" style={{ fontSize: 13 }}>
        <span className="text-muted">{discount?.label}</span>
        <span className="fw-medium text-success">{fIDR(discount?.amount)}</span>
      </div>
    )}
    <div className="d-flex justify-content-between align-items-center pt-2 mt-1 border-top" style={{ fontSize: 13 }}>
      <span className="fw-semibold">Total</span>
      <span className="fw-semibold" style={{ fontSize: 15 }}>{fIDR(finalTotal)}</span>
    </div>
  </div>
)
}